import { Component } from '@angular/core';

@Component({
  selector: 'app-jd-connected',
  standalone: false,
  templateUrl: './jd-connected.component.html',
  styleUrls: ['./jd-connected.component.css']
})
export class JdConnectedComponent {}
